import styled from "styled-components";
import gloria from "assets/images/NH21_722_ELLE_GLORIA1967.jpg";

export const Container = styled.section`
  display: flex;
  width: 100%;
  height: 100vh;
  background: black url(${gloria}) no-repeat center center;
  background-size: cover;
  position: relative;
  align-items: center;
  justify-content: center;
`;
